import React, { useState, useEffect, memo, useRef } from "react";
import Formsy from "formsy-react";
import { MySelect } from "../../../Shared/Forms/Select";

import { Row, Col, Button, Spinner, UncontrolledAlert, Card, CardBody, CardHeader } from "reactstrap";
import { MdFileUpload, MdClose } from "react-icons/md";

import FoodLibraryDropDown from "../../MealPlan/FoodLibraryDropDown";
//import EditAsyncFoodItemDropDown from "./EditAsyncFoodItemDropDown";
import MealRoasterEditor from "../../../Shared/Forms/MealRoasterEditor";
import "./roasterMealPlans.css";
//import { GiConsoleController } from "react-icons/gi";
import ConfirmationModal from "../../../Shared/ConfirmationModal";
import { TextInput } from "../../../Shared/Forms";
const options = [
    { key: "BreakFast", value: 2 },
    { key: "Lunch", value: 3 },
    { key: "Dinner", value: 4 },
    { key: "Snack", value: 5 },
    // { key: "Others", value: 1 },
];
// const mockData = [
//     {
//         day: 1,
//         plan: [
//             {
//                 mealType: 1,
//                 meal: [
//                     {
//                         name: "egg",
//                         nutrients: [
//                             {
//                                 key: "calories",
//                                 value: 3.5,
//                             },
//                         ],
//                     },
//                     {
//                         name: "pawpaw",
//                         nutrients: [
//                             {
//                                 key: "calories",
//                                 value: 3.5,
//                             },
//                         ],
//                     },
//                 ],
//                 recipe: "pppp",
//             },
//             {
//                 mealType: 2,
//                 meal: [
//                     {
//                         name: "mango",
//                         nutrients: [
//                             {
//                                 key: "calories",
//                                 value: 3.5,
//                             },
//                         ],
//                     },
//                     {
//                         name: "fried rice",
//                         nutrients: [
//                             {
//                                 key: "calories",
//                                 value: 3.5,
//                             },
//                         ],
//                     },
//                 ],
//                 recipe: "rrr",
//             },
//         ],
//         updatedAt: "",
//         createdAt: "",
//     },
// ];

const EditRoasterPlanForm = memo((props) => {
    const { submitted, submitting, totalNumDays, handleSubmit, formError, dailyReset, submitToAdmin, mealRoasterFormModal, responseRoaster, updateDailyMealRoaster, roasterHideFormCss, resetRoasterFormCss, showDeleteModal, status, reviewerRemarks } = props;
    const editRoasterMealFormRef = useRef("editMealRoasterForm");
    const [roaster, setRoaster] = useState([]);
    const [mealPlansDays, setMealPlansDays] = useState([]);

    //  const [mealType, setMealTypes] = useState(options);

    const [isEdit, setIsEdit] = useState(true);
    // when change on the meal plan type select
    const [newAddArray, setNewAddArray] = useState([]);
    //help in showing each meal plan type in specific day.
    const [mapNewAddArray, setMapNewAddArray] = useState([]);
    const [mapNewMealType, setMapNewMealType] = useState([]);
    const [mapNewRecipeArry, setMapNewRecipeArry] = useState([]);
    const [mapFoodItemSelected, setMapFoodItemSelected] = useState([]);
    const [mapHideRoasterCss, setMapHideRoasterCss] = useState([]);
    // validation states
    const [canSubmit, setCanSubmit] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [roasterId, setRoasterId] = useState(null);
    //handle food items quantity..
    const [storeFoodItems, setStoreFoodItem] = useState([]);
    const [roasterFoodItemArry, setRoasterFoodItemArry] = useState([]);
    const [nonRoasterFoodItemArry, setNonRoasterFoodItemArry] = useState([]);
    const [roasterFoodItemQty, setRoasterFoodItemQty] = useState([]);
    const [nonRoasterFoodItemQty, setNonRoasterFoodItemQty] = useState([]);
    //handle food recipe title
    const [storeRecipeRosterTitle, setStoreRecipeRosterTitle] = useState([]);
    const [storeRecipeNonRosterTitle, setStoreRecipeNonRosterTitle] = useState([]);
    const stopEdit = () => {
        setIsEdit(!isEdit);
    };

    const updateDailyRoaster = (day) => {
        let extractMeaIData = [];
        if (day >= 0) {
            if (roaster && roaster[day]) {
                let cloneRecipeTitle = JSON.parse(JSON.stringify(storeRecipeRosterTitle));

                let getMealTypeRecipeTitle = [];
                for (let j = 0; j < roaster[day].plan.length; j++) {
                    //loop through food item to search for type and add it up.
                    for (let k = 0; k < cloneRecipeTitle[day].length; k++) {
                        if (roaster[day].plan[j].mealType === cloneRecipeTitle[day][k].mealType) {
                            getMealTypeRecipeTitle.push(cloneRecipeTitle[day][k].title);
                        }
                    }
                }

                //if not 1 in the food item arry it simply mean it has been change so replaced
                extractMeaIData = roaster[day].plan.map((v, i) => {
                    return {
                        mealType: v.mealType,
                        meal: v.meal,

                        recipe: { content: v.recipe.content, title: getMealTypeRecipeTitle[i] === 1 ? v.recipe.title : getMealTypeRecipeTitle[i] },
                    };
                });
            }

            //check for cases when not in roaster.

            let cloneFoodItemsNotInRoster = JSON.parse(JSON.stringify(nonRoasterFoodItemArry));

            let cloneFoodItemsQtyNotInRoster = JSON.parse(JSON.stringify(nonRoasterFoodItemQty));
            if (mapFoodItemSelected && mapFoodItemSelected[day]) {
                let cloneNonRoasterRecipeTitle = JSON.parse(JSON.stringify(storeRecipeNonRosterTitle));
                //LOOP TO GET THOSE WITH DATA IN IT
                let extractedNonRosterRecipeTitle = [];
                for (let p = 0; p < cloneNonRoasterRecipeTitle[day].length; p++) {
                    if (cloneNonRoasterRecipeTitle[day][p].title !== 1) {
                        extractedNonRosterRecipeTitle.push(cloneNonRoasterRecipeTitle[day][p]);
                    }
                }

                let filterNullMeal = mapFoodItemSelected[day].filter((e) => e.meal !== null);

                for (let r = 0; r < cloneFoodItemsNotInRoster[day].length; r++) {
                    for (let p = 0; p < cloneFoodItemsQtyNotInRoster[day].length; p++) {
                        if (cloneFoodItemsNotInRoster[day][r].mealType === cloneFoodItemsQtyNotInRoster[day][p].mealType) {
                            if (cloneFoodItemsNotInRoster[day][r].meal !== null) {
                                let newQtyArr = cloneFoodItemsQtyNotInRoster[day][p].quantity;

                                for (let o = 0; o < cloneFoodItemsNotInRoster[day][r].meal.length; o++) {
                                    //check for meal name.
                                    for (let m = 0; m < newQtyArr.length; m++) {
                                        if (cloneFoodItemsNotInRoster[day][r].meal[o].name === newQtyArr[m].name) {
                                            for (let w = 0; w < cloneFoodItemsNotInRoster[day][r].meal[o].nutrients.length; w++) {
                                                cloneFoodItemsNotInRoster[day][r].meal[o].nutrients[w].value = cloneFoodItemsNotInRoster[day][r].meal[o].nutrients[w].value * newQtyArr[m].quantity;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                let filterNullRecipe = mapNewRecipeArry[day].filter((e) => e.recipe !== null);
                for (let k = 0; k < filterNullMeal.length; k++) {
                    if (filterNullMeal[k].mealType === filterNullRecipe[k].mealType) {
                        filterNullMeal[k].recipe = filterNullRecipe[k].recipe;
                    }
                }

                //check if filter return an empty array hence don't add to the main plan...
                //then check for the reciepe...normally it should have reciepe concepto.
                //refactor me...
                //prevent undefined on both roaster and non-roaster.
                for (let e = 0; e < filterNullMeal.length; e++) {
                    for (let r = 0; r < extractedNonRosterRecipeTitle.length; r++) {
                        if (filterNullMeal[e].mealType === extractedNonRosterRecipeTitle[r].mealType) {
                            filterNullMeal[e].recipe = { content: filterNullMeal[e].recipe, title: extractedNonRosterRecipeTitle[r].title };
                        }
                    }
                    extractMeaIData.push(filterNullMeal[e]);
                }
            }

            //for non roster......
            for (let i = 0; i < extractMeaIData.length; i++) {
                for (let k = 0; k < cloneFoodItemsQtyNotInRoster[day].length; k++) {
                    if (extractMeaIData[i].mealType === cloneFoodItemsQtyNotInRoster[day][k].mealType) {
                        if (cloneFoodItemsQtyNotInRoster[day][k].quantity !== 1) {
                            for (let m = 0; m < extractMeaIData[i].meal.length; m++) {
                                extractMeaIData[i].meal[m].quantity = cloneFoodItemsQtyNotInRoster[day][k].quantity[m].quantity;
                                for (let p = 0; p < extractMeaIData[i].meal[m].nutrients.length; p++) {
                                    extractMeaIData[i].meal[m].nutrients[p] = { key: extractMeaIData[i].meal[m].nutrients[p].key, value: extractMeaIData[i].meal[m].nutrients[p].value * cloneFoodItemsQtyNotInRoster[day][k].quantity[m].quantity };
                                }
                            }
                        }
                    }
                }
            }

            //check if the roasterFoodItemQty have been change
            let cloneFoodItemsQtyInRoster = JSON.parse(JSON.stringify(roasterFoodItemQty));
            let isRoasterQtyTouch = false;
            let counter = 0;
            
            if (cloneFoodItemsQtyInRoster[day]) {
                for (let e = 0; e < cloneFoodItemsQtyInRoster[day].length; e++) {
                    if (cloneFoodItemsQtyInRoster[day][e].quantity.length !== 0) {
                        isRoasterQtyTouch = true;
                        break;
                    } else {
                        counter += 1;
                        if (counter === 4) {
                            isRoasterQtyTouch = false;
                        }
                    }
                }
            }

            if (isRoasterQtyTouch) {
                //picking everything from the store qty arry
                for (let i = 0; i < extractMeaIData.length; i++) {
                    for (let k = 0; k < cloneFoodItemsQtyInRoster[day].length; k++) {
                        if (extractMeaIData[i].mealType === cloneFoodItemsQtyInRoster[day][k].mealType) {
                            if (cloneFoodItemsQtyInRoster[day][k].quantity.length !== 0) {
                                for (let m = 0; m < extractMeaIData[i].meal.length; m++) {
                                    extractMeaIData[i].meal[m].quantity = cloneFoodItemsQtyInRoster[day][k].quantity[m];
                                    for (let p = 0; p < extractMeaIData[i].meal[m].nutrients.length; p++) {
                                        extractMeaIData[i].meal[m].nutrients[p] = { key: extractMeaIData[i].meal[m].nutrients[p].key, value: extractMeaIData[i].meal[m].nutrients[p].value * cloneFoodItemsQtyInRoster[day][k].quantity[m] };
                                    }
                                }
                            }
                        }
                    }
                }
            }

            if (extractMeaIData.length > 0) {
                let addDay = day + 1;
                let refinedData = {
                    day: addDay,
                    plan: extractMeaIData,
                };

                updateDailyMealRoaster(refinedData);
            }
        }
    };
    const submitDailyMealPlan = (e) => {
        let breakFastFoodItems = [];
        let lunchFoodItems = [];
        let dinnerFoodItems = [];
        let snackFoodItems = [];
        let otherFoodItems = [];
        let plans = [];
    };

    const isMealTypeInRoasterFromDropDown = (mealCode, roaster, day) => {
        try {
            if (mealCode >= 0) {
                // check in the roaster arry.
                let plans = roaster.map((e) => e.plan);

                if (plans && plans[day]) {
                    for (let i = 0; i < plans[day].length; i++) {
                        if (plans[day][i].mealType === mealCode) {
                            return true;
                        }
                    }
                }

                return false;
            }
        } catch (e) {
            console.error(e);
        }
    };

    //have to refactor you later.
    const checkIfMealTypeIsInRoaster = (arr, day, mealCode) => {
        if (arr.length > 0 && day >= 0) {
            if (arr[day] && arr[day].plan.length > 0) {
                for (let i = 0; i < arr[day].plan.length; i++) {
                    if (arr[day].plan[i].mealType === mealCode) {
                        return true;
                    }
                }
                return false;
            } else {
                return false;
            }
        } else {
            return false;
        }
    };

    const addFoodItemToSelectedArry = (data, day, mealTypeCode) => {
        try {
            if (data) {
                let cloneFoodItemArry = JSON.parse(JSON.stringify(mapFoodItemSelected));

                for (let i = 0; i < cloneFoodItemArry[day].length; i++) {
                    if (cloneFoodItemArry[day][i].mealType === mealTypeCode) {
                        cloneFoodItemArry[day][i].meal = data;

                        setMapFoodItemSelected(cloneFoodItemArry);
                        break;
                    }
                }
            }
        } catch (e) {
            console.error(e);
        }
    };
    const addFoodItemFromDropDown = (data, day, mealTypeCode) => {
        try {
            //pick the exact array index from the day given
            if (data) {
                let isInRoaster = isMealTypeInRoasterFromDropDown(mealTypeCode, roaster, day);

                hideDailyRoasterFormCss(day, mapHideRoasterCss);
                if (isInRoaster) {
                    let cloneArry = JSON.parse(JSON.stringify(roaster));
                    if (cloneArry) {
                        if (cloneArry && cloneArry[day] && cloneArry[day].plan) {
                            for (let i = 0; i < cloneArry[day].plan.length; i++) {
                                if (cloneArry[day].plan[i].mealType === mealTypeCode) {
                                    cloneArry[day].plan[i].meal = data;

                                    setRoaster(cloneArry);
                                }
                            }
                        }
                    }
                } else {
                    addFoodItemToSelectedArry(data, day, mealTypeCode);
                }
            }
        } catch (e) {
            console.error(e);
        }
    };
    const showMapMealPlanForm = (key, day) => {
        try {
            let duplicateArr = [...mapNewAddArray];

            for (let i = 0; i < duplicateArr.length; i++) {
                if (i === day) {
                    duplicateArr[i].push(key);
                }
            }
            setMapNewAddArray(duplicateArr);
        } catch (e) {
            console.error(e);
        }
    };
    const removeMapMealPlanTypeFromSelect = (key, day) => {
        try {
            let duplicateArr = [...mapNewMealType];
            let filterArr = [];

            for (let i = 0; i < duplicateArr.length; i++) {
                if (i === day) {
                    filterArr = duplicateArr[i].filter((e) => e.key !== key);

                    duplicateArr.splice(i, 1, filterArr);
                }
            }

            setMapNewMealType(duplicateArr);
        } catch (e) {
            console.error(e);
        }
    };
    const removeMealTypeOnCancelClick = (meal, day) => {
        try {
            let duplicateArr = [...mapNewAddArray];
            let filterArr = [];

            for (let i = 0; i < duplicateArr.length; i++) {
                if (i === day) {
                    filterArr = duplicateArr[i].filter((e) => e !== meal);

                    duplicateArr.splice(i, 1, filterArr);
                }
            }

            setMapNewAddArray(duplicateArr);
        } catch (e) {
            console.error(e);
        }
    };
    const hideDailyRoasterFormCss = (day, arr) => {
        try {
            let cloneRoasterCss = JSON.parse(JSON.stringify(arr));
            if (cloneRoasterCss.length > 0) {
                for (let i = 0; i < cloneRoasterCss.length; i++) {
                    if (i === day) {
                        cloneRoasterCss[i] = false;
                    } else {
                        cloneRoasterCss[i] = true;
                    }
                }

                setMapHideRoasterCss(cloneRoasterCss);
            }
        } catch (e) {
            console.error(e);
        }
    };
    const resetDailyRoasterFormCss = (arr) => {
        try {
            let cloneResetRoasterCss = JSON.parse(JSON.stringify(arr));
            if (cloneResetRoasterCss.length > 0) {
                for (let i = 0; i < cloneResetRoasterCss.length; i++) {
                    cloneResetRoasterCss[i] = false;
                }

                setMapHideRoasterCss(cloneResetRoasterCss);
            }
        } catch (e) {
            console.error(e);
        }
    };
    const onChange = (e, day) => {
        try {
            if (e) {
                let isMealPlanInRoaster = isMealTypeInRoasterFromDropDown(e.value, roaster, day);

                if (isMealPlanInRoaster) {
                    return null;
                } else {
                    hideDailyRoasterFormCss(day, mapHideRoasterCss);
                    showMapMealPlanForm(e.key, day);
                    removeMapMealPlanTypeFromSelect(e.key, day);
                }
            }
        } catch (e) {
            console.error(e);
        }
    };
    const enableButton = () => {
        setCanSubmit(true);
    };
    const disableButton = () => {
        setCanSubmit(false);
    };

    const mapMealType = (mealType) => {
        switch (mealType) {
            case 1:
                return "Others";
            case 2:
                return "BreakFast";
            case 3:
                return "Lunch";
            case 4:
                return "Dinner";
            case 5:
                return "Snack";
        }
    };
    const reverseMapMealType = (mealType) => {
        switch (mealType) {
            case "Others":
                return 1;
            case "BreakFast":
                return 2;
            case "Lunch":
                return 3;
            case "Dinner":
                return 4;
            case "Snack":
                return 5;
        }
    };
    const mapRemoveMealPlanType = (meal, day) => {
        try {
            let mealTypeCode = reverseMapMealType(meal);

            let cloneArr = JSON.parse(JSON.stringify(mapNewMealType));
            cloneArr[day].push({ key: meal, value: mealTypeCode });
            setMapNewMealType(cloneArr);
            removeMealTypeOnCancelClick(meal, day);
        } catch (e) {
            console.error(e);
        }
    };

    const extractFoodItemName = (arr, isRoaster) => {
        try {
            let mealName = arr.map((e) => e.name);
            let mealId = arr.map((e) => e.id);
            let mealNutrients = arr.map((e) => e.nutrients);
            let mealMeasures = arr.map((e) => e.measure);
            let mealQty = arr.map((e) => e.quantity);
            let modifiedData = [{ name: null, id: "34355322" }];

            for (let i = 0; i < mealName.length; i++) {
                modifiedData[i] = { name: mealName[i], id: mealId && mealId[i] ? mealId[i] : `6666${i}`, nutrients: mealNutrients[i], measure: mealMeasures && mealMeasures[i] ? mealMeasures[i] : 1, quantity: mealQty && mealQty[i] };
            }

            return modifiedData;
        } catch (e) {
            console.error(e);
        }
    };
    const addRecipeToArry = (day, data, mealType) => {
        try {
            let cloneRecipeArry = JSON.parse(JSON.stringify(mapNewRecipeArry));
            for (let i = 0; i < cloneRecipeArry.length; i++) {
                if (i === day) {
                    for (let k = 0; k < cloneRecipeArry[i].length; k++) {
                        if (cloneRecipeArry[i] && cloneRecipeArry[i][k].mealType === mealType) {
                            cloneRecipeArry[i][k].recipe = data;
                            setMapNewRecipeArry(cloneRecipeArry);
                            break;
                        }
                    }
                }
            }
        } catch (e) {
            console.error(exports);
        }
    };
    const storeRecipeDataMap = (day, mealType, reciepeData) => {
        try {
            //check if it is in roaster or not by checking base on mealtype
            let isInRoaster = checkIfMealTypeIsInRoaster(roaster, day, mealType);
            hideDailyRoasterFormCss(day, mapHideRoasterCss);
            if (isInRoaster) {
                let cloneRoaster = JSON.parse(JSON.stringify(roaster));

                if (cloneRoaster.length && cloneRoaster[day].plan.length > 0) {
                    //loop and use meal type to get the exact arr to change the receipts.
                    for (let i = 0; i < cloneRoaster[day].plan.length; i++) {
                        if (cloneRoaster[day].plan[i].mealType === mealType) {
                            cloneRoaster[day].plan[i].recipe = reciepeData;
                            setRoaster(cloneRoaster);

                            break;
                        }
                    }
                }
            } else {
                addRecipeToArry(day, reciepeData, mealType);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const removeMealPlanFromRoaster = (meal, day) => {
        let mealType = meal && meal.mealType;

        try {
            if (roaster.length > 0) {
                setIsEdit(true);
                let cloneRoasterArr = JSON.parse(JSON.stringify(roaster));

                for (let i = 0; i <= cloneRoasterArr[day].plan.length; i++) {
                    if (cloneRoasterArr[day].plan[i].mealType === mealType) {
                        cloneRoasterArr[day].plan.splice(i, 1);

                        break;
                    }
                }

                setRoaster(cloneRoasterArr);
            }
        } catch (e) {
            console.error(e);
            setIsEdit(false);
        }
    };

    const storeRecipeTitle = (data, day, mealType, isRoster) => {
        try {
            //store it in a unique array type base on day and the meal type.
            if (isRoster) {
                let cloneRecipeTitle = JSON.parse(JSON.stringify(storeRecipeRosterTitle));
                for (let k = 0; k < cloneRecipeTitle[day].length; k++) {
                    if (cloneRecipeTitle[day][k].mealType === mealType) {
                        cloneRecipeTitle[day][k].title = data;
                        setStoreRecipeRosterTitle(cloneRecipeTitle);

                        break;
                    }
                }
            } else {
                let cloneRecipeNonRoaster = JSON.parse(JSON.stringify(storeRecipeNonRosterTitle));
                for (let k = 0; k < cloneRecipeNonRoaster[day].length; k++) {
                    if (cloneRecipeNonRoaster[day][k].mealType === mealType) {
                        cloneRecipeNonRoaster[day][k].title = data;
                        setStoreRecipeNonRosterTitle(cloneRecipeNonRoaster);
                        break;
                    }
                }
            }
        } catch (e) {
            console.error(e);
        }
    };

    /// handle all food item quantity calculation
    const getPlansOnlyFromRoaster = (roaster) => {
        let i = 0;
        let k = 0;
        let tempPlan = [];
        for (i; i < roaster.length; i++) {
            tempPlan.push(roaster[i].plan);
        }

        return tempPlan;
    };
    const qtyIndexGetter = (mealType) => {
        switch (mealType) {
            case 2:
                return 0;
            case 3:
                return 1;
            case 4:
                return 2;
            case 5:
                return 3;
        }
    };
    const addFoodItemToArry = (foodItem, day, mealType, isRoaster, nonRoasterIndex) => {
        try {
            hideDailyRoasterFormCss(day, mapHideRoasterCss);
            if (isRoaster) {
                //pls i need to check the type of data structure.
                let cloneFoodRoasterItemQty = JSON.parse(JSON.stringify(roasterFoodItemQty));
                // SETTING THE QUANTITY.
                if (roasterFoodItemArry[day] !== undefined || roasterFoodItemArry[day] !== null) {
                    let cloneFoodItem = JSON.parse(JSON.stringify(roasterFoodItemArry));

                    for (let i = 0; i < cloneFoodItem[day].length; i++) {
                        if (cloneFoodItem[day][i].mealType === mealType) {
                            cloneFoodItem[day][i]["meal"] = foodItem;

                            setRoasterFoodItemArry(cloneFoodItem);
                            break;
                        }
                    }

                    let getArryToLoop = [];
                    for (let m = 0; m < cloneFoodRoasterItemQty[day].length; m++) {
                        if (cloneFoodRoasterItemQty[day][m].mealType === mealType) {
                            getArryToLoop.push(cloneFoodRoasterItemQty[day][m]);
                        }
                    }
                    for (let k = 0; k < foodItem.length; k++) {
                        if (foodItem[k].quantity !== undefined) {
                            if (getArryToLoop[0].quantity[k] === undefined) {
                                getArryToLoop[0].quantity.push(foodItem[k].quantity);
                            } else {
                                getArryToLoop[0].quantity[k] = getArryToLoop[0].quantity[k];
                            }
                        } else {
                            if (getArryToLoop[0].quantity[k] === undefined) {
                                getArryToLoop[0].quantity.push(1);
                            } else {
                                getArryToLoop[0].quantity[k] = getArryToLoop[0].quantity[k];
                            }
                        }
                    }

                    //store it at the main database
                    for (let m = 0; m < cloneFoodRoasterItemQty[day].length; m++) {
                        if (cloneFoodRoasterItemQty[day][m].mealType === mealType) {
                            cloneFoodRoasterItemQty[day][m] = getArryToLoop[0];
                        }
                    }
                    setRoasterFoodItemQty(cloneFoodRoasterItemQty);
                }
            } else {
                //to handle no roaster
                //best calculation to be done on update period....
                if (nonRoasterFoodItemArry[day] !== undefined || nonRoasterFoodItemArry[day] !== null) {
                    let cloneNonRoasterFoodItem = JSON.parse(JSON.stringify(nonRoasterFoodItemArry));
                    let cloneStoreQty = JSON.parse(JSON.stringify(nonRoasterFoodItemQty));

                    let extractStoreDataDetailsQty = 0;
                    let index = 0;
                    if (cloneStoreQty[day].length > 0) {
                        //check for type
                        index = qtyIndexGetter(mealType);
                        extractStoreDataDetailsQty = cloneStoreQty[day][index];
                    }
                    if (extractStoreDataDetailsQty.quantity === 1) {
                        for (let i = 0; i < foodItem.length; i++) {
                            foodItem[i]["quantity"] = 1;

                            cloneStoreQty[day][index]["quantity"] = [{ name: foodItem[i].name, quantity: 1 }];
                        }

                        setNonRoasterFoodItemQty(cloneStoreQty);
                    } else {
                        //loop through the clone food item.check if the food item name dey my store already

                        for (let i = 0; i < foodItem.length; i++) {
                            if (foodItem[i].quantity === undefined) {
                                foodItem[i]["quantity"] = 1;
                                cloneStoreQty[day][index]["quantity"].push({ name: foodItem[i].name, quantity: 1 });

                                setNonRoasterFoodItemQty(cloneStoreQty);
                            }
                        }
                    }

                    if (cloneNonRoasterFoodItem[day].length > 0) {
                        //look for the mealtype to change the meal
                        for (let i = 0; i < cloneNonRoasterFoodItem[day].length; i++) {
                            if (cloneNonRoasterFoodItem[day][i].mealType === mealType) {
                                cloneNonRoasterFoodItem[day][i]["meal"] = foodItem;

                                setNonRoasterFoodItemArry(cloneNonRoasterFoodItem);
                            }
                        }
                    }
                }
            }
        } catch (e) {
            console.error(e);
        }
    };
    const calculteFoodItemCaloriesOnChange = (data, day, mealType, isRoaster, index) => {
        try {
            if (isRoaster) {
                if (roasterFoodItemArry[day] !== undefined || roasterFoodItemArry[day] !== null) {
                    let parseQty = parseFloat(data);
                    let cloneFoodItemArry = JSON.parse(JSON.stringify(roasterFoodItemArry));
                    let cloneFoodRoasterItemQty = JSON.parse(JSON.stringify(roasterFoodItemQty));

                    //PENDING WORK HERE .....day ,mealType,quantity index.
                    for (let i = 0; i < cloneFoodRoasterItemQty[day].length; i++) {
                        if (cloneFoodRoasterItemQty[day][i].mealType === mealType) {
                            //loop and look for it's index haha
                            for (let k = 0; k < cloneFoodRoasterItemQty[day][i].quantity.length; k++) {
                                //check of index
                                if (k === index) {
                                    cloneFoodRoasterItemQty[day][i].quantity[k] = parseQty;
                                    setRoasterFoodItemQty(cloneFoodRoasterItemQty);
                                    break;
                                }
                            }
                        }
                    }
                }
            } else {
                if (nonRoasterFoodItemArry[day] !== undefined || nonRoasterFoodItemArry[day] !== null) {
                    let parseQty = parseFloat(data);

                    let cloneFoodItemArry = JSON.parse(JSON.stringify(nonRoasterFoodItemArry));
                    let cloneFoodItemQty = JSON.parse(JSON.stringify(nonRoasterFoodItemQty));
                    //locate the meal type to get the quantity store there.
                    for (let i = 0; i < cloneFoodItemQty[day].length; i++) {
                        if (cloneFoodItemQty[day][i].mealType == mealType) {
                            //loop through at look for the qty to mutate.
                            for (let k = 0; k < cloneFoodItemQty[day][i]["quantity"].length; k++) {
                                if (k === index) {
                                    cloneFoodItemQty[day][i]["quantity"][k].quantity = parseQty;
                                    setNonRoasterFoodItemQty(cloneFoodItemQty);
                                }
                            }
                        }
                    }

                    for (let i = 0; i < cloneFoodItemArry[day].length; i++) {
                        if (cloneFoodItemArry[day][i].mealType === mealType) {
                            if (cloneFoodItemArry[day][i].meal !== null) {
                                for (let k = 0; k < cloneFoodItemArry[day][i]["meal"].length; k++) {
                                    //check for index
                                    if (k === index) {
                                        cloneFoodItemArry[day][i].meal[k]["quantity"] = parseQty;
                                        //loop through the array hahaha.....
                                        for (let p = 0; p < cloneFoodItemArry[day][i].meal[k]["nutrients"].length; p++) {
                                            cloneFoodItemArry[day][i].meal[k]["nutrients"][p].value = cloneFoodItemArry[day][i].meal[k]["nutrients"][p].value * parseQty;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    setNonRoasterFoodItemArry(cloneFoodItemArry);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    ////end here\\\\\\\\\\\\\\\\\\\\\\\\\
    useEffect(() => {
        if (roasterHideFormCss) {
            resetRoasterFormCss();
            //reset everything back to false
            resetDailyRoasterFormCss(mapHideRoasterCss);
        }
    }, [roasterHideFormCss]);

    useEffect(() => {
        if (typeof responseRoaster != "undefined" && responseRoaster != null && responseRoaster.length != null && responseRoaster.length > 0) {
            setRoaster(responseRoaster);

            let roasteReciepeTitle = [];
            let resetRosterFoodItemsQty = [];
            for (let i = 0; i < responseRoaster.length; i++) {
                roasteReciepeTitle[i] = [
                    { mealType: 2, title: 1 },
                    { mealType: 3, title: 1 },
                    { mealType: 4, title: 1 },
                    { mealType: 5, title: 1 },
                ];
                resetRosterFoodItemsQty[i] = [
                    { mealType: 2, quantity: [] },
                    { mealType: 3, quantity: [] },
                    { mealType: 4, quantity: [] },
                    { mealType: 5, quantity: [] },
                ];
            }

            setStoreRecipeRosterTitle(roasteReciepeTitle);
            setRoasterFoodItemQty(resetRosterFoodItemsQty);

            let roasterItems = getPlansOnlyFromRoaster(responseRoaster);

            setRoasterFoodItemArry(roasterItems);
        } else {
            setRoaster([]);
        }
    }, [responseRoaster]);

    useEffect(() => {
        if (totalNumDays > 0) {
            let resetMealPlansDays = [];
            let resetNewAddArry = [];
            let resetNewMealType = [];
            let resetNewRecipeArry = [];
            let resetFoodItemSelected = [];
            let resetHideRoasterCss = [];
            let resetStoreFoodItems = [];
            let resetFoodItemsForNonRoasterArry = [];
            let resetRosterFoodItemsQty = [];
            let resetNonRosterFoodItemsQty = [];
            let resetRecipeTitleRoaster = [];
            let resetNonRosterRecipeTitle = [];

            for (let i = 0; i < totalNumDays; i++) {
                resetMealPlansDays[i] = i;
                resetNewAddArry[i] = [];
                resetNewMealType[i] = options;
                resetNewRecipeArry[i] = [
                    { mealType: 1, recipe: null },
                    { mealType: 2, recipe: null },
                    { mealType: 3, recipe: null },
                    { mealType: 4, recipe: null },
                    { mealType: 5, recipe: null },
                ];
                resetFoodItemSelected[i] = [
                    { mealType: 1, meal: null },
                    { mealType: 2, meal: null },
                    { mealType: 3, meal: null },
                    { mealType: 4, meal: null },
                    { mealType: 5, meal: null },
                ];
                resetHideRoasterCss[i] = false;
                resetStoreFoodItems[i] = [];
                resetFoodItemsForNonRoasterArry[i] = [
                    { mealType: 2, meal: null },
                    { mealType: 3, meal: null },
                    { mealType: 4, meal: null },
                    { mealType: 5, meal: null },
                ];

                resetNonRosterFoodItemsQty[i] = [
                    { mealType: 2, quantity: 1 },
                    { mealType: 3, quantity: 1 },
                    { mealType: 4, quantity: 1 },
                    { mealType: 5, quantity: 1 },
                ];
                resetNonRosterRecipeTitle[i] = [
                    { mealType: 2, title: 1 },
                    { mealType: 3, title: 1 },
                    { mealType: 4, title: 1 },
                    { mealType: 5, title: 1 },
                ];
            }
            setMealPlansDays(resetMealPlansDays);
            setMapNewAddArray(resetNewAddArry);
            setMapNewMealType(resetNewMealType);
            setMapNewRecipeArry(resetNewRecipeArry);
            setMapFoodItemSelected(resetFoodItemSelected);
            setMapHideRoasterCss(resetHideRoasterCss);
            ////items store
            setStoreFoodItem(resetStoreFoodItems);
            setNonRoasterFoodItemArry(resetFoodItemsForNonRoasterArry);
            setRoasterFoodItemQty(resetRosterFoodItemsQty);
            setNonRoasterFoodItemQty(resetNonRosterFoodItemsQty);
            setStoreRecipeNonRosterTitle(resetNonRosterRecipeTitle);
        }
    }, [totalNumDays]);

    const showConfirmation = (day) => {
        setShowModal(!showModal);
        if (typeof roaster != "undefined" && roaster != null && roaster.length != null && roaster.length > 0) {
            try {
                let newRoasterId = roaster[day].id;
                if (newRoasterId !== null) {
                    setRoasterId(newRoasterId);
                }
            } catch (error) {
                console.error(error);
            }
        }
    };
    const deleteDailyMealRoaster = (id) => {
        showDeleteModal(id);
        setShowModal(!showModal);
    };
    return (
        <React.Fragment>
            <Row>
                <Col sm="12" md={{ size: 6, offset: status === "DECLINED" ? 2 : 3 }} className={mealRoasterFormModal ? "hideEditMealPlan" : null}>
                    {
                        <Card>
                            <CardHeader className="mb-2">Meal Roster</CardHeader>
                            {mealPlansDays &&
                                mealPlansDays.map((e, index) => (
                                    <CardBody className="mealRoasterFrame mb-2" id={e} className={mapHideRoasterCss[e] ? `hideEditMealPlan mealRoasterFrame mb-2` : `mealRoasterFrame mb-2`}>
                                        <span className="cancelflexcontainer spacebetween mb-3">
                                            Day {e + 1}
                                            {roaster.length - 1 === e ? <MdClose className="remove-icon" style={{ cursor: "pointer", color: "red" }} onClick={() => showConfirmation(e)} /> : null}
                                        </span>
                                        <Formsy onValidSubmit={submitDailyMealPlan} onValid={enableButton} onInvalid={disableButton} noValidate>
                                            {formError && !formError.errors ? <UncontrolledAlert color="danger">{formError.message}</UncontrolledAlert> : null}
                                            {formError && formError.errors ? (
                                                <UncontrolledAlert color="danger">
                                                    {formError.errors.map((error, index) => (
                                                        <p key={index}>{error.message}</p>
                                                    ))}
                                                </UncontrolledAlert>
                                            ) : null}
                                            <MySelect isMulti={false} name={"meal"} isClearable={false} onChange={onChange} title={"Select your meal type"} options={mapNewMealType[e]} valueKey="value" labelKey="key" isRequired={true} defaultOptions={null} id={e} />
                                            {roaster &&
                                                roaster[e] &&
                                                roaster[e].plan.map((i, k) =>
                                                    i && i.mealType === 2 ? (
                                                        <Card id={k} className="mb-2">
                                                            <CardHeader className="cancelflexcontainer spacebetween">
                                                                MEAL TYPE : {mapMealType(i.mealType)}
                                                                {<MdClose className="remove-icon" style={{ cursor: "pointer", color: "red" }} onClick={() => removeMealPlanFromRoaster(i, e)} />}
                                                            </CardHeader>
                                                            <CardBody>
                                                                <FoodLibraryDropDown
                                                                    isMulti={true}
                                                                    isClearable={true}
                                                                    name="BreakFastMeal"
                                                                    title="Select food item"
                                                                    value={i && i.meal ? extractFoodItemName(i.meal, true) : null}
                                                                    selectedMetrics
                                                                    valueKey="id"
                                                                    isRequired={true}
                                                                    onChange={addFoodItemFromDropDown}
                                                                    day={e}
                                                                    mealTypeCode={i && i.mealType}
                                                                    id={e}
                                                                    addFoodItemToArry={addFoodItemToArry}
                                                                    mealModulus={true}
                                                                    isRoaster={true}
                                                                />
                                                                {roasterFoodItemArry &&
                                                                    roasterFoodItemArry[e].map((itemValue, index) =>
                                                                        itemValue && itemValue["mealType"] === 2 ? (
                                                                            <div id={index}>
                                                                                {itemValue["meal"].map((value, key) => (
                                                                                    <React.Fragment key={key}>
                                                                                        <Card id={key} className="mb-2">
                                                                                            <CardBody>
                                                                                                <Row className="measurementSpaces mb-2">
                                                                                                    <Col>
                                                                                                        {" "}
                                                                                                        <small>{"Food Item"}</small>
                                                                                                    </Col>
                                                                                                    <Col>
                                                                                                        <small>{"Metric Unit"}</small>
                                                                                                    </Col>
                                                                                                    <Col>
                                                                                                        <small>{"Quantity"}</small>
                                                                                                    </Col>
                                                                                                </Row>
                                                                                                <Row className="measurementSpaces">
                                                                                                    <Col>
                                                                                                        <small>{value && value.name}</small>
                                                                                                    </Col>
                                                                                                    <Col>
                                                                                                        <small>{value && value.measure}</small>
                                                                                                    </Col>
                                                                                                    <Col>
                                                                                                        <TextInput
                                                                                                            id={`unit${key}`}
                                                                                                            name={`unit${key}`}
                                                                                                            required
                                                                                                            value={value && value.quantity}
                                                                                                            validations={{
                                                                                                                isNumeric: true,
                                                                                                                matchRegexp: /(^[1-9]+(\d+)?(\.\d+)?$)|(^0\.\d+$)/,
                                                                                                            }}
                                                                                                            validationErrors={{
                                                                                                                isNumeric: "Whole numbers or decimals numbers only allowed",
                                                                                                                matchRegexp: "Whole numbers or decimals numbers only allowed",
                                                                                                            }}
                                                                                                            onChange={(data) => calculteFoodItemCaloriesOnChange(data, e, 2, true, key)}
                                                                                                        />
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </CardBody>
                                                                                        </Card>
                                                                                    </React.Fragment>
                                                                                ))}
                                                                            </div>
                                                                        ) : null
                                                                    )}{" "}
                                                                <TextInput
                                                                    name="breakfastRecipeTitle"
                                                                    day={e}
                                                                    mealTypeCode={i && i.mealType}
                                                                    id={k}
                                                                    required
                                                                    title="Recipe Title"
                                                                    validations={{
                                                                        minLength: 5,
                                                                    }}
                                                                    validationErrors={{
                                                                        minLength: "Minimum of 5 characters allowed",
                                                                        maxLength: "Maximum of 50 characters allowed",
                                                                    }}
                                                                    value={i && i.recipe && i.recipe.title ? i.recipe.title : null}
                                                                    onChange={(data) => storeRecipeTitle(data, e, 2, true)}
                                                                />
                                                                <MealRoasterEditor
                                                                    name="breakFastrecipe"
                                                                    value={i && i.recipe && i.recipe.content ? i.recipe.content : null}
                                                                    postBody={i && i.recipe ? i.recipe.content : null}
                                                                    isEdit={isEdit}
                                                                    stopEdit={stopEdit}
                                                                    required
                                                                    disabled={submitting}
                                                                    validations={{
                                                                        minLength: 13,
                                                                    }}
                                                                    validationErrors={{
                                                                        minLength: "Minimum of 3 characters allowed",
                                                                    }}
                                                                    toolbarHidden={false}
                                                                    title="Details of your Recipe"
                                                                    stripPastedStyles={true}
                                                                    isMultiArry={true}
                                                                    storeDataInTextArry={storeRecipeDataMap}
                                                                    mealType={i.mealType}
                                                                    day={e}
                                                                />
                                                            </CardBody>
                                                        </Card>
                                                    ) : i && i.mealType === 3 ? (
                                                        <Card id={k} className="mb-2">
                                                            <CardHeader className="cancelflexcontainer spacebetween">
                                                                MEAL TYPE : {mapMealType(i.mealType)}
                                                                {<MdClose className="remove-icon" style={{ cursor: "pointer", color: "red" }} onClick={() => removeMealPlanFromRoaster(i, e)} />}
                                                            </CardHeader>
                                                            <CardBody>
                                                                <FoodLibraryDropDown
                                                                    isMulti={true}
                                                                    isClearable={true}
                                                                    name="BreakFastMeal"
                                                                    title="Select food item"
                                                                    value={i && i.meal ? extractFoodItemName(i.meal, true) : null}
                                                                    selectedMetrics
                                                                    valueKey="id"
                                                                    isRequired={true}
                                                                    onChange={addFoodItemFromDropDown}
                                                                    day={e}
                                                                    mealTypeCode={i && i.mealType}
                                                                    id={e}
                                                                    addFoodItemToArry={addFoodItemToArry}
                                                                    mealModulus={true}
                                                                    isRoaster={true}
                                                                />

                                                                {roasterFoodItemArry &&
                                                                    roasterFoodItemArry[e].map(
                                                                        (itemValue, index) =>
                                                                            itemValue && itemValue["mealType"] === 3 ? (
                                                                                <div id={index}>
                                                                                    {itemValue["meal"].map((value, key) => (
                                                                                        <React.Fragment key={key}>
                                                                                            <Card id={key} className="mb-2">
                                                                                                <CardBody>
                                                                                                    <Row className="measurementSpaces mb-2">
                                                                                                        <Col>
                                                                                                            {" "}
                                                                                                            <small>{"Food Item"}</small>
                                                                                                        </Col>
                                                                                                        <Col>
                                                                                                            <small>{"Metric Unit"}</small>
                                                                                                        </Col>
                                                                                                        <Col>
                                                                                                            <small>{"Quantity"}</small>
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                    <Row className="measurementSpaces">
                                                                                                        <Col>
                                                                                                            <small>{value && value.name}</small>
                                                                                                        </Col>
                                                                                                        <Col>
                                                                                                            <small>{value && value.measure}</small>
                                                                                                        </Col>
                                                                                                        <Col>
                                                                                                            <TextInput
                                                                                                                id={`unit${key}`}
                                                                                                                name={`unit${key}`}
                                                                                                                required
                                                                                                                value={value && value.quantity}
                                                                                                                validations={{
                                                                                                                    isNumeric: true,
                                                                                                                    matchRegexp: /(^[1-9]+(\d+)?(\.\d+)?$)|(^0\.\d+$)/,
                                                                                                                }}
                                                                                                                validationErrors={{
                                                                                                                    isNumeric: "Whole numbers or decimals numbers only allowed",
                                                                                                                    matchRegexp: "Whole numbers or decimals numbers only allowed",
                                                                                                                }}
                                                                                                                onChange={(data) => calculteFoodItemCaloriesOnChange(data, e, 3, true, key)}
                                                                                                            />
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                </CardBody>
                                                                                            </Card>
                                                                                        </React.Fragment>
                                                                                    ))}
                                                                                </div>
                                                                            ) : null
                                                                        //please note all belongs to the same day and meal type.
                                                                    )}
                                                                <TextInput
                                                                    name="lunchRecipeTitle"
                                                                    day={e}
                                                                    mealTypeCode={i && i.mealType}
                                                                    id={k}
                                                                    required
                                                                    title="Recipe Title"
                                                                    validations={{
                                                                        minLength: 5,
                                                                    }}
                                                                    validationErrors={{
                                                                        minLength: "Minimum of 5 characters allowed",
                                                                        maxLength: "Maximum of 50 characters allowed",
                                                                    }}
                                                                    value={i && i.recipe && i.recipe.title ? i.recipe.title : null}
                                                                    onChange={(data) => storeRecipeTitle(data, e, 3, true)}
                                                                />
                                                                <MealRoasterEditor
                                                                    name="breakFastrecipe"
                                                                    value={i && i.recipe && i.recipe.content ? i.recipe.content : null}
                                                                    postBody={i && i.recipe && i.recipe.content ? i.recipe.content : null}
                                                                    isEdit={isEdit}
                                                                    stopEdit={stopEdit}
                                                                    required
                                                                    disabled={submitting}
                                                                    validations={{
                                                                        minLength: 13,
                                                                    }}
                                                                    validationErrors={{
                                                                        minLength: "Minimum of 3 characters allowed",
                                                                    }}
                                                                    toolbarHidden={false}
                                                                    title="Details of your Recipe"
                                                                    stripPastedStyles={true}
                                                                    isMultiArry={true}
                                                                    storeDataInTextArry={storeRecipeDataMap}
                                                                    mealType={i.mealType}
                                                                    day={e}
                                                                />
                                                            </CardBody>
                                                        </Card>
                                                    ) : i && i.mealType === 5 ? (
                                                        <Card id={k} className="mb-2">
                                                            <CardHeader className="cancelflexcontainer spacebetween">
                                                                MEAL TYPE : {mapMealType(i.mealType)}
                                                                {<MdClose className="remove-icon" style={{ cursor: "pointer", color: "red" }} onClick={() => removeMealPlanFromRoaster(i, e)} />}
                                                            </CardHeader>
                                                            <CardBody>
                                                                <FoodLibraryDropDown
                                                                    isMulti={true}
                                                                    isClearable={true}
                                                                    name="BreakFastMeal"
                                                                    title="Select food item"
                                                                    value={i && i.meal ? extractFoodItemName(i.meal, true) : null}
                                                                    selectedMetrics
                                                                    valueKey="id"
                                                                    isRequired={true}
                                                                    onChange={addFoodItemFromDropDown}
                                                                    day={e}
                                                                    mealTypeCode={i && i.mealType}
                                                                    id={e}
                                                                    addFoodItemToArry={addFoodItemToArry}
                                                                    mealModulus={true}
                                                                    isRoaster={true}
                                                                />

                                                                {roasterFoodItemArry &&
                                                                    roasterFoodItemArry[e].map(
                                                                        (itemValue, index) =>
                                                                            itemValue && itemValue["mealType"] === 5 ? (
                                                                                <div id={index}>
                                                                                    {itemValue["meal"].map((value, key) => (
                                                                                        <React.Fragment id={key}>
                                                                                            <Card id={key} className="mb-2">
                                                                                                <CardBody>
                                                                                                    <Row className="measurementSpaces mb-2">
                                                                                                        <Col>
                                                                                                            {" "}
                                                                                                            <small>{"Food Item"}</small>
                                                                                                        </Col>
                                                                                                        <Col>
                                                                                                            <small>{"Metric Unit"}</small>
                                                                                                        </Col>
                                                                                                        <Col>
                                                                                                            <small>{"Quantity"}</small>
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                    <Row className="measurementSpaces">
                                                                                                        <Col>
                                                                                                            <small>{value && value.name}</small>
                                                                                                        </Col>
                                                                                                        <Col>
                                                                                                            <small>{value && value.measure}</small>
                                                                                                        </Col>
                                                                                                        <Col>
                                                                                                            <TextInput
                                                                                                                id={`unit${key}`}
                                                                                                                name={`unit${key}`}
                                                                                                                required
                                                                                                                value={value && value.quantity}
                                                                                                                validations={{
                                                                                                                    isNumeric: true,
                                                                                                                    matchRegexp: /(^[1-9]+(\d+)?(\.\d+)?$)|(^0\.\d+$)/,
                                                                                                                }}
                                                                                                                validationErrors={{
                                                                                                                    isNumeric: "Whole numbers or decimals numbers only allowed",
                                                                                                                    matchRegexp: "Whole numbers or decimals numbers only allowed",
                                                                                                                }}
                                                                                                                onChange={(data) => calculteFoodItemCaloriesOnChange(data, e, 5, true, key)}
                                                                                                            />
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                </CardBody>
                                                                                            </Card>
                                                                                        </React.Fragment>
                                                                                    ))}
                                                                                </div>
                                                                            ) : null
                                                                        //please note all belongs to the same day and meal type.
                                                                    )}
                                                                <TextInput
                                                                    name="snackRecipeTitle"
                                                                    day={e}
                                                                    mealTypeCode={i && i.mealType}
                                                                    id={k}
                                                                    required
                                                                    title="Recipe Title"
                                                                    validations={{
                                                                        minLength: 5,
                                                                    }}
                                                                    validationErrors={{
                                                                        minLength: "Minimum of 5 characters allowed",
                                                                        maxLength: "Maximum of 50 characters allowed",
                                                                    }}
                                                                    value={i && i.recipe && i.recipe.title ? i.recipe.title : null}
                                                                    onChange={(data) => storeRecipeTitle(data, e, 5, true)}
                                                                />
                                                                <MealRoasterEditor
                                                                    name="breakFastrecipe"
                                                                    value={i && i.recipe && i.recipe.content ? i.recipe.content : null}
                                                                    postBody={i && i.recipe ? i.recipe.content : null}
                                                                    isEdit={isEdit}
                                                                    stopEdit={stopEdit}
                                                                    required
                                                                    disabled={submitting}
                                                                    validations={{
                                                                        minLength: 13,
                                                                    }}
                                                                    validationErrors={{
                                                                        minLength: "Minimum of 3 characters allowed",
                                                                    }}
                                                                    toolbarHidden={false}
                                                                    title="Details of your Recipe"
                                                                    stripPastedStyles={true}
                                                                    isMultiArry={true}
                                                                    storeDataInTextArry={storeRecipeDataMap}
                                                                    mealType={i.mealType}
                                                                    day={e}
                                                                />
                                                            </CardBody>
                                                        </Card>
                                                    ) : i && i.mealType === 4 ? (
                                                        <Card id={k} className="mb-2">
                                                            <CardHeader className="cancelflexcontainer spacebetween">
                                                                MEAL TYPE : {mapMealType(i.mealType)}
                                                                {<MdClose className="remove-icon" style={{ cursor: "pointer", color: "red" }} onClick={() => removeMealPlanFromRoaster(i, e)} />}
                                                            </CardHeader>
                                                            <CardBody>
                                                                <FoodLibraryDropDown
                                                                    isMulti={true}
                                                                    isClearable={true}
                                                                    name="BreakFastMeal"
                                                                    title="Select food item"
                                                                    value={i && i.meal ? extractFoodItemName(i.meal, true) : null}
                                                                    selectedMetrics
                                                                    valueKey="id"
                                                                    isRequired={true}
                                                                    onChange={addFoodItemFromDropDown}
                                                                    day={e}
                                                                    mealTypeCode={i && i.mealType}
                                                                    id={e}
                                                                    addFoodItemToArry={addFoodItemToArry}
                                                                    mealModulus={true}
                                                                    isRoaster={true}
                                                                />

                                                                {roasterFoodItemArry &&
                                                                    roasterFoodItemArry[e].map(
                                                                        (itemValue, index) =>
                                                                            itemValue && itemValue["mealType"] === 4 ? (
                                                                                <div id={index}>
                                                                                    {itemValue["meal"].map((value, key) => (
                                                                                        <React.Fragment id={key}>
                                                                                            <Card id={key} className="mb-2">
                                                                                                <CardBody>
                                                                                                    <Row className="measurementSpaces mb-2">
                                                                                                        <Col>
                                                                                                            {" "}
                                                                                                            <small>{"Food Item"}</small>
                                                                                                        </Col>
                                                                                                        <Col>
                                                                                                            <small>{"Metric Unit"}</small>
                                                                                                        </Col>
                                                                                                        <Col>
                                                                                                            <small>{"Quantity"}</small>
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                    <Row className="measurementSpaces">
                                                                                                        <Col>
                                                                                                            <small>{value && value.name}</small>
                                                                                                        </Col>
                                                                                                        <Col>
                                                                                                            <small>{value && value.measure}</small>
                                                                                                        </Col>
                                                                                                        <Col>
                                                                                                            <TextInput
                                                                                                                id={`unit${key}`}
                                                                                                                name={`unit${key}`}
                                                                                                                required
                                                                                                                value={value && value.quantity}
                                                                                                                validations={{
                                                                                                                    isNumeric: true,
                                                                                                                    matchRegexp: /(^[1-9]+(\d+)?(\.\d+)?$)|(^0\.\d+$)/,
                                                                                                                }}
                                                                                                                validationErrors={{
                                                                                                                    isNumeric: "Whole numbers or decimals numbers only allowed",
                                                                                                                    matchRegexp: "Whole numbers or decimals numbers only allowed",
                                                                                                                }}
                                                                                                                onChange={(data) => calculteFoodItemCaloriesOnChange(data, e, 4, true, key)}
                                                                                                            />
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                </CardBody>
                                                                                            </Card>
                                                                                        </React.Fragment>
                                                                                    ))}
                                                                                </div>
                                                                            ) : null
                                                                        //please note all belongs to the same day and meal type.
                                                                    )}
                                                                <TextInput
                                                                    name="dinnerRecipeTitle"
                                                                    day={e}
                                                                    mealTypeCode={i && i.mealType}
                                                                    id={k}
                                                                    required
                                                                    title="Recipe Title"
                                                                    validations={{
                                                                        minLength: 5,
                                                                    }}
                                                                    validationErrors={{
                                                                        minLength: "Minimum of 5 characters allowed",
                                                                        maxLength: "Maximum of 50 characters allowed",
                                                                    }}
                                                                    value={i && i.recipe && i.recipe.title ? i.recipe.title : null}
                                                                    onChange={(data) => storeRecipeTitle(data, e, 4, true)}
                                                                />
                                                                <MealRoasterEditor
                                                                    name="breakFastrecipe"
                                                                    value={i && i.recipe && i.recipe.content ? i.recipe.content : null}
                                                                    postBody={i && i.recipe ? i.recipe.content : null}
                                                                    isEdit={isEdit}
                                                                    stopEdit={stopEdit}
                                                                    required
                                                                    disabled={submitting}
                                                                    validations={{
                                                                        minLength: 13,
                                                                    }}
                                                                    validationErrors={{
                                                                        minLength: "Minimum of 3 characters allowed",
                                                                    }}
                                                                    toolbarHidden={false}
                                                                    title="Details of your Recipe"
                                                                    stripPastedStyles={true}
                                                                    isMultiArry={true}
                                                                    storeDataInTextArry={storeRecipeDataMap}
                                                                    mealType={i.mealType}
                                                                    day={e}
                                                                />
                                                            </CardBody>
                                                        </Card>
                                                    ) : null
                                                )}
                                            {mapNewAddArray[e].map((mealPlanType, index) =>
                                                mealPlanType === "BreakFast" ? (
                                                    <Card className="mb-4" id={index}>
                                                        <CardHeader className="cancelflexcontainer spacebetween">
                                                            <span>{mealPlanType} </span>
                                                            {<MdClose className="remove-icon" onClick={() => mapRemoveMealPlanType(mealPlanType, e)} style={{ cursor: "pointer", color: "red" }} />}
                                                        </CardHeader>
                                                        <CardBody>
                                                            <FoodLibraryDropDown
                                                                id={index}
                                                                isMulti={true}
                                                                isClearable={true}
                                                                name="BreakFastMeal"
                                                                title="Select food item"
                                                                value={null}
                                                                selectedMetrics
                                                                valueKey="id"
                                                                isRequired={true}
                                                                onChange={addFoodItemFromDropDown}
                                                                day={e}
                                                                mealTypeCode={reverseMapMealType(mealPlanType)}
                                                                addFoodItemToArry={addFoodItemToArry}
                                                                mealModulus={true}
                                                                isRoaster={false}
                                                                index={index}
                                                            />

                                                            {nonRoasterFoodItemArry &&
                                                                nonRoasterFoodItemArry[e].map(
                                                                    (itemValue, nonIndex) =>
                                                                        itemValue.mealType === 2 &&
                                                                        itemValue.meal &&
                                                                        itemValue.meal.map((value, key) => (
                                                                            <React.Fragment key={key}>
                                                                                <Card id={key} className="mb-2">
                                                                                    <CardBody>
                                                                                        <Row className="measurementSpaces mb-2">
                                                                                            <Col>
                                                                                                {" "}
                                                                                                <small>{"Food Item"}</small>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <small>{"Metric Unit"}</small>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <small>{"Quantity"}</small>
                                                                                            </Col>
                                                                                        </Row>
                                                                                        <Row className="measurementSpaces">
                                                                                            <Col>
                                                                                                <small>{value && value.name}</small>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <small>{value && value.measure}</small>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <TextInput
                                                                                                    id={`unit${key}`}
                                                                                                    name={`unit${key}`}
                                                                                                    required
                                                                                                    value={"1"}
                                                                                                    validations={{
                                                                                                        isNumeric: true,
                                                                                                        matchRegexp: /(^[1-9]+(\d+)?(\.\d+)?$)|(^0\.\d+$)/,
                                                                                                    }}
                                                                                                    validationErrors={{
                                                                                                        isNumeric: "Whole numbers or decimals numbers only allowed",
                                                                                                        matchRegexp: "Whole numbers or decimals numbers only allowed",
                                                                                                    }}
                                                                                                    onChange={(data) => calculteFoodItemCaloriesOnChange(data, e, 2, false, key)}
                                                                                                />
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </CardBody>
                                                                                </Card>
                                                                            </React.Fragment>
                                                                        ))
                                                                )}
                                                            <TextInput
                                                                name="breakFastRecipeTitle"
                                                                day={e}
                                                                mealTypeCode={2}
                                                                id={index}
                                                                required
                                                                title="Recipe Title"
                                                                validations={{
                                                                    minLength: 5,
                                                                }}
                                                                validationErrors={{
                                                                    minLength: "Minimum of 5 characters allowed",
                                                                    maxLength: "Maximum of 50 characters allowed",
                                                                }}
                                                                value={null}
                                                                onChange={(data) => storeRecipeTitle(data, e, 2, false)}
                                                            />
                                                            <MealRoasterEditor
                                                                name="breakFastrecipe"
                                                                value={null}
                                                                required
                                                                disabled={submitting}
                                                                validations={{
                                                                    minLength: 13,
                                                                }}
                                                                validationErrors={{
                                                                    minLength: "Minimum of 3 characters allowed",
                                                                }}
                                                                toolbarHidden={false}
                                                                title="Details of your Recipe"
                                                                stripPastedStyles={true}
                                                                isMultiArry={true}
                                                                storeDataInTextArry={storeRecipeDataMap}
                                                                mealType={reverseMapMealType(mealPlanType)}
                                                                day={e}
                                                            />
                                                        </CardBody>
                                                    </Card>
                                                ) : mealPlanType === "Lunch" ? (
                                                    <Card className="mb-4" id={index}>
                                                        <CardHeader className="cancelflexcontainer spacebetween">
                                                            <span>{mealPlanType} </span>
                                                            {<MdClose className="remove-icon" onClick={() => mapRemoveMealPlanType(mealPlanType, e)} style={{ cursor: "pointer", color: "red" }} />}
                                                        </CardHeader>
                                                        <CardBody>
                                                            <FoodLibraryDropDown
                                                                id={index}
                                                                isMulti={true}
                                                                isClearable={true}
                                                                name="LunchMeal"
                                                                title="Select food item"
                                                                value={null}
                                                                selectedMetrics
                                                                valueKey="id"
                                                                isRequired={true}
                                                                onChange={addFoodItemFromDropDown}
                                                                day={e}
                                                                mealTypeCode={reverseMapMealType(mealPlanType)}
                                                                addFoodItemToArry={addFoodItemToArry}
                                                                mealModulus={true}
                                                                isRoaster={false}
                                                                index={index}
                                                            />
                                                            {nonRoasterFoodItemArry &&
                                                                nonRoasterFoodItemArry[e].map(
                                                                    (itemValue, nonIndex) =>
                                                                        itemValue.mealType === 3 &&
                                                                        itemValue.meal &&
                                                                        itemValue.meal.map((value, key) => (
                                                                            <React.Fragment key={key}>
                                                                                <Card id={key} className="mb-2">
                                                                                    <CardBody>
                                                                                        <Row className="measurementSpaces mb-2">
                                                                                            <Col>
                                                                                                {" "}
                                                                                                <small>{"Food Item"}</small>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <small>{"Metric Unit"}</small>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <small>{"Quantity"}</small>
                                                                                            </Col>
                                                                                        </Row>
                                                                                        <Row className="measurementSpaces">
                                                                                            <Col>
                                                                                                <small>{value && value.name}</small>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <small>{value && value.measure}</small>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <TextInput
                                                                                                    id={`unit${key}`}
                                                                                                    name={`unit${key}`}
                                                                                                    required
                                                                                                    value={"1"}
                                                                                                    validations={{
                                                                                                        isNumeric: true,
                                                                                                        matchRegexp: /(^[1-9]+(\d+)?(\.\d+)?$)|(^0\.\d+$)/,
                                                                                                    }}
                                                                                                    validationErrors={{
                                                                                                        isNumeric: "Whole numbers or decimals numbers only allowed",
                                                                                                        matchRegexp: "Whole numbers or decimals numbers only allowed",
                                                                                                    }}
                                                                                                    onChange={(data) => calculteFoodItemCaloriesOnChange(data, e, 3, false, key)}
                                                                                                />
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </CardBody>
                                                                                </Card>
                                                                            </React.Fragment>
                                                                        ))
                                                                )}
                                                            <TextInput
                                                                name="lunchRecipeTitle"
                                                                day={e}
                                                                mealTypeCode={3}
                                                                id={index}
                                                                required
                                                                title="Recipe Title"
                                                                validations={{
                                                                    minLength: 5,
                                                                }}
                                                                validationErrors={{
                                                                    minLength: "Minimum of 5 characters allowed",
                                                                    maxLength: "Maximum of 50 characters allowed",
                                                                }}
                                                                value={null}
                                                                onChange={(data) => storeRecipeTitle(data, e, 3, false)}
                                                            />
                                                            <MealRoasterEditor
                                                                name="lunchrecipe"
                                                                value={null}
                                                                required
                                                                disabled={submitting}
                                                                validations={{
                                                                    minLength: 13,
                                                                }}
                                                                validationErrors={{
                                                                    minLength: "Minimum of 3 characters allowed",
                                                                }}
                                                                toolbarHidden={false}
                                                                title="Details of your Recipe"
                                                                stripPastedStyles={true}
                                                                isMultiArry={true}
                                                                storeDataInTextArry={storeRecipeDataMap}
                                                                mealType={reverseMapMealType(mealPlanType)}
                                                                day={e}
                                                            />
                                                        </CardBody>
                                                    </Card>
                                                ) : mealPlanType === "Dinner" ? (
                                                    <Card className="mb-4" id={index}>
                                                        <CardHeader className="cancelflexcontainer spacebetween">
                                                            <span>{mealPlanType} </span>
                                                            {<MdClose className="remove-icon" onClick={() => mapRemoveMealPlanType(mealPlanType, e)} style={{ cursor: "pointer", color: "red" }} />}
                                                        </CardHeader>
                                                        <CardBody>
                                                            <FoodLibraryDropDown
                                                                id={index}
                                                                isMulti={true}
                                                                isClearable={true}
                                                                name="DinnerMeal"
                                                                title="Select food item"
                                                                value={null}
                                                                selectedMetrics
                                                                valueKey="id"
                                                                isRequired={true}
                                                                onChange={addFoodItemFromDropDown}
                                                                day={e}
                                                                mealTypeCode={reverseMapMealType(mealPlanType)}
                                                                addFoodItemToArry={addFoodItemToArry}
                                                                mealModulus={true}
                                                                isRoaster={false}
                                                                index={index}
                                                            />
                                                            {nonRoasterFoodItemArry &&
                                                                nonRoasterFoodItemArry[e].map(
                                                                    (itemValue, nonIndex) =>
                                                                        itemValue.mealType === 4 &&
                                                                        itemValue.meal &&
                                                                        itemValue.meal.map((value, key) => (
                                                                            <React.Fragment key={key}>
                                                                                <Card id={key} className="mb-2">
                                                                                    <CardBody>
                                                                                        <Row className="measurementSpaces mb-2">
                                                                                            <Col>
                                                                                                {" "}
                                                                                                <small>{"Food Item"}</small>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <small>{"Metric Unit"}</small>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <small>{"Quantity"}</small>
                                                                                            </Col>
                                                                                        </Row>
                                                                                        <Row className="measurementSpaces">
                                                                                            <Col>
                                                                                                <small>{value && value.name}</small>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <small>{value && value.measure}</small>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <TextInput
                                                                                                    id={`unit${key}`}
                                                                                                    name={`unit${key}`}
                                                                                                    required
                                                                                                    value={"1"}
                                                                                                    validations={{
                                                                                                        isNumeric: true,
                                                                                                        matchRegexp: /(^[1-9]+(\d+)?(\.\d+)?$)|(^0\.\d+$)/,
                                                                                                    }}
                                                                                                    validationErrors={{
                                                                                                        isNumeric: "Whole numbers or decimals numbers only allowed",
                                                                                                        matchRegexp: "Whole numbers or decimals numbers only allowed",
                                                                                                    }}
                                                                                                    onChange={(data) => calculteFoodItemCaloriesOnChange(data, e, 4, false, key)}
                                                                                                />
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </CardBody>
                                                                                </Card>
                                                                            </React.Fragment>
                                                                        ))
                                                                )}
                                                            <TextInput
                                                                name="dinnerRecipeTitle"
                                                                day={e}
                                                                mealTypeCode={4}
                                                                id={index}
                                                                required
                                                                title="Recipe Title"
                                                                validations={{
                                                                    minLength: 5,
                                                                }}
                                                                validationErrors={{
                                                                    minLength: "Minimum of 5 characters allowed",
                                                                    maxLength: "Maximum of 50 characters allowed",
                                                                }}
                                                                value={null}
                                                                onChange={(data) => storeRecipeTitle(data, e, 4, false)}
                                                            />
                                                            <MealRoasterEditor
                                                                name="dinnerrecipe"
                                                                value={null}
                                                                required
                                                                disabled={submitting}
                                                                validations={{
                                                                    minLength: 13,
                                                                }}
                                                                validationErrors={{
                                                                    minLength: "Minimum of 3 characters allowed",
                                                                }}
                                                                toolbarHidden={false}
                                                                title="Details of your Recipe"
                                                                stripPastedStyles={true}
                                                                isMultiArry={true}
                                                                storeDataInTextArry={storeRecipeDataMap}
                                                                mealType={reverseMapMealType(mealPlanType)}
                                                                day={e}
                                                            />
                                                        </CardBody>
                                                    </Card>
                                                ) : mealPlanType === "Snack" ? (
                                                    <Card className="mb-4" id={index}>
                                                        <CardHeader className="cancelflexcontainer spacebetween">
                                                            <span>{mealPlanType} </span>
                                                            {<MdClose className="remove-icon" onClick={() => mapRemoveMealPlanType(mealPlanType, e)} style={{ cursor: "pointer", color: "red" }} />}
                                                        </CardHeader>
                                                        <CardBody>
                                                            <FoodLibraryDropDown
                                                                id={index}
                                                                isMulti={true}
                                                                isClearable={true}
                                                                name="SnackMeal"
                                                                title="Select food item"
                                                                value={null}
                                                                selectedMetrics
                                                                valueKey="id"
                                                                isRequired={true}
                                                                onChange={addFoodItemFromDropDown}
                                                                day={e}
                                                                mealTypeCode={reverseMapMealType(mealPlanType)}
                                                                addFoodItemToArry={addFoodItemToArry}
                                                                mealModulus={true}
                                                                isRoaster={false}
                                                                index={index}
                                                            />
                                                            {nonRoasterFoodItemArry &&
                                                                nonRoasterFoodItemArry[e].map(
                                                                    (itemValue, nonIndex) =>
                                                                        itemValue.mealType === 5 &&
                                                                        itemValue.meal &&
                                                                        itemValue.meal.map((value, key) => (
                                                                            <React.Fragment key={key}>
                                                                                <Card id={key} className="mb-2">
                                                                                    <CardBody>
                                                                                        <Row className="measurementSpaces mb-2">
                                                                                            <Col>
                                                                                                {" "}
                                                                                                <small>{"Food Item"}</small>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <small>{"Metric Unit"}</small>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <small>{"Quantity"}</small>
                                                                                            </Col>
                                                                                        </Row>
                                                                                        <Row className="measurementSpaces">
                                                                                            <Col>
                                                                                                <small>{value && value.name}</small>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <small>{value && value.measure}</small>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <TextInput
                                                                                                    id={`unit${key}`}
                                                                                                    name={`unit${key}`}
                                                                                                    required
                                                                                                    value={"1"}
                                                                                                    validations={{
                                                                                                        isNumeric: true,
                                                                                                        matchRegexp: /(^[1-9]+(\d+)?(\.\d+)?$)|(^0\.\d+$)/,
                                                                                                    }}
                                                                                                    validationErrors={{
                                                                                                        isNumeric: "Whole numbers or decimals numbers only allowed",
                                                                                                        matchRegexp: "Whole numbers or decimals numbers only allowed",
                                                                                                    }}
                                                                                                    onChange={(data) => calculteFoodItemCaloriesOnChange(data, e, 5, false, key)}
                                                                                                />
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </CardBody>
                                                                                </Card>
                                                                            </React.Fragment>
                                                                        ))
                                                                )}
                                                            <TextInput
                                                                name="snackRecipeTitle"
                                                                day={e}
                                                                mealTypeCode={5}
                                                                id={index}
                                                                required
                                                                title="Recipe Title"
                                                                validations={{
                                                                    minLength: 5,
                                                                }}
                                                                validationErrors={{
                                                                    minLength: "Minimum of 5 characters allowed",
                                                                    maxLength: "Maximum of 50 characters allowed",
                                                                }}
                                                                value={null}
                                                                onChange={(data) => storeRecipeTitle(data, e, 5, false)}
                                                            />
                                                            <MealRoasterEditor
                                                                name="Snackrecipe"
                                                                value={null}
                                                                required
                                                                disabled={submitting}
                                                                validations={{
                                                                    minLength: 13,
                                                                }}
                                                                validationErrors={{
                                                                    minLength: "Minimum of 3 characters allowed",
                                                                }}
                                                                toolbarHidden={false}
                                                                title="Details of your Recipe"
                                                                stripPastedStyles={true}
                                                                isMultiArry={true}
                                                                storeDataInTextArry={storeRecipeDataMap}
                                                                mealType={reverseMapMealType(mealPlanType)}
                                                                day={e}
                                                            />
                                                        </CardBody>
                                                    </Card>
                                                ) : mealPlanType === "Others" ? (
                                                    <Card className="mb-4" id={index}>
                                                        <CardHeader className="cancelflexcontainer spacebetween">
                                                            <span>{mealPlanType} </span>
                                                            {<MdClose className="remove-icon" onClick={() => mapRemoveMealPlanType(mealPlanType, e)} style={{ cursor: "pointer", color: "red" }} />}
                                                        </CardHeader>
                                                        <CardBody>
                                                            <FoodLibraryDropDown
                                                                isMulti={true}
                                                                isClearable={true}
                                                                name="OtherMeal"
                                                                title="Select food item"
                                                                value={null}
                                                                selectedMetrics
                                                                valueKey="id"
                                                                isRequired={true}
                                                                onChange={addFoodItemFromDropDown}
                                                                day={e}
                                                                mealTypeCode={reverseMapMealType(mealPlanType)}
                                                            />
                                                            <MealRoasterEditor
                                                                name="Otherrecipe"
                                                                value={null}
                                                                required
                                                                disabled={submitting}
                                                                validations={{
                                                                    minLength: 13,
                                                                }}
                                                                validationErrors={{
                                                                    minLength: "Minimum of 3 characters allowed",
                                                                }}
                                                                toolbarHidden={false}
                                                                title="Details of your Recipe"
                                                                stripPastedStyles={true}
                                                                isMultiArry={true}
                                                                storeDataInTextArry={storeRecipeDataMap}
                                                                mealType={reverseMapMealType(mealPlanType)}
                                                                day={e}
                                                            />
                                                        </CardBody>
                                                    </Card>
                                                ) : null
                                            )}
                                            {true ? (
                                                <Button type="button" color="primary" onClick={() => updateDailyRoaster(e)} id={e}>
                                                    {submitting ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        <span>
                                                            {"Update"} <MdFileUpload size={20} />
                                                        </span>
                                                    )}
                                                </Button>
                                            ) : null}
                                        </Formsy>
                                    </CardBody>
                                ))}
                        </Card>
                    }
                </Col>
                {status === "DECLINED" ? (
                    <aside>
                        <Card style={{ minWidth: "20rem" }}>
                            <CardHeader>Redraft Comment</CardHeader>
                            <CardBody>
                                <p>{reviewerRemarks}</p>
                            </CardBody>
                        </Card>
                    </aside>
                ) : null}
            </Row>
            {/* </Formsy> */}
            {<ConfirmationModal isOpen={showModal} showModal={showConfirmation} action={deleteDailyMealRoaster} message={"Do you want to delete this meal roaster ?"} item={roasterId} />}
        </React.Fragment>
    );
});

export default EditRoasterPlanForm;
